export default (that) => [
  {
    field: 'orderProofingCode',
    width: 40,
    align: 'center',
    type: 'seq',
    merge: true,
  },
  {
    title: '打样编码（隐藏）',
    field: 'orderProofingCode',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    merge: true,
    mergeByKey: true,
    visible: false,
  },
  {
    title: that.$l('INDEX.proofing_label_proofingType') || '打样类型',
    field: 'v_proofingType',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    merge: true,
  },
  {
    title: that.$l('INDEX.proofing_label_demandTime') || '需求时间',
    field: 'demandTime',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    merge: true,
  },
  {
    title: that.$l('INDEX.proofing_label_qty') || '需求数量',
    field: 'qty',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    merge: true,
  },
  {
    title: that.$l('INDEX.proofing_label_sampleUse') || '样品用途',
    field: 'sampleUse',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    merge: true,
  },
  {
    title: that.$l('INDEX.proofing_label_proofingRequirement') || '交付要求',
    field: 'proofingRequirement',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    merge: true,
  },
  {
    title: that.$l('INDEX.proofing_label_photoRequirement') || '拍摄要求',
    field: 'photoRequirement',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    merge: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    merge: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    merge: true,
  },
  {
    title:
      that.$l('INDEX.order_goods_label_orderGoods_information') || '产品信息',
    align: 'center',
    children: [
      {
        title: that.$l('INDEX.proofing_goods_label_goodsQty') || '样品数量',
        field: 'goosQty',
        width: 120,
        align: 'center',
        showHeaderOverflow: true,
        showOverflow: true,
      },
      {
        title: that.$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号',
        field: 'orderGoodsNo',
        width: 150,
        align: 'center',
        showOverflow: true,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号',
        field: 'identifyGoodsNo',
        width: 230,
        headerAlign: 'center',
        align: 'left',
        showHeaderOverflow: true,
        showOverflow: true,
      },
      {
        title: that.$l('INDEX.order_goods_label_orderGoodsName') || '产品名称',
        field: 'orderGoodsDisplayName',
        minWidth: 450,
        align: 'left',
        headerAlign: 'center',
        showHeaderOverflow: true,
        showOverflow: true,
      },
    ],
  },
]
